import { PayloadAction, ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { IResponseWithPagination } from "src/@types/api";
import { IClone } from "src/@types/clones";
import { IInquiry } from "src/@types/inquiries";
import { IUserProfileCard, IUser } from "src/@types/users";
import {
  getUserProfileCardSidebarAsync,
  getUserProfileClonesAsync,
  getUserProfileInfoAsync,
  getUserProfileInquiriesAsync,
} from "./actions";
import { UsersState } from "./slice";

type ActionReducerMapBuilderWithUsersState =
  ActionReducerMapBuilder<UsersState>;

export const getUserProfileInfoReducer = (
  builder: ActionReducerMapBuilderWithUsersState
) => {
  builder.addCase(getUserProfileInfoAsync.pending, (state) => {
    state.userProfileInfo.isLoading = true;
  });

  builder.addCase(
    getUserProfileInfoAsync.fulfilled,
    (state, actions: PayloadAction<IUser>) => {
      state.userProfileInfo.isLoading = false;
      state.userProfileInfo.data = actions.payload;
    }
  );

  builder.addCase(getUserProfileInfoAsync.rejected, (state) => {
    state.userProfileInfo.isLoading = false;
    state.userProfileInfo.data = null;
  });
};

export const getUserProfileCardSidebarReducer = (
  builder: ActionReducerMapBuilderWithUsersState
) => {
  builder.addCase(getUserProfileCardSidebarAsync.pending, (state) => {
    state.userProfileCard.isLoading = true;
  });

  builder.addCase(
    getUserProfileCardSidebarAsync.fulfilled,
    (state, actions: PayloadAction<IUserProfileCard>) => {
      state.userProfileCard.isLoading = false;
      state.userProfileCard.data = actions.payload;
    }
  );

  builder.addCase(getUserProfileCardSidebarAsync.rejected, (state) => {
    state.userProfileCard.isLoading = false;
    state.userProfileCard.data = null;
  });
};

export const getUserProfileClonesReducer = (
  builder: ActionReducerMapBuilderWithUsersState
) => {
  builder.addCase(getUserProfileClonesAsync.pending, (state) => {
    state.clones.isLoading = true;
  });

  builder.addCase(
    getUserProfileClonesAsync.fulfilled,
    (state, actions: PayloadAction<IResponseWithPagination<IClone>>) => {
      state.clones.isLoading = false;
      state.clones.data = actions.payload;
    }
  );

  builder.addCase(getUserProfileClonesAsync.rejected, (state) => {
    state.clones.isLoading = false;
    state.clones.data = null;
  });
};

export const getUserProfileInquiriesReducer = (
  builder: ActionReducerMapBuilderWithUsersState
) => {
  builder.addCase(getUserProfileInquiriesAsync.pending, (state) => {
    state.inquiries.isLoading = true;
  });

  builder.addCase(
    getUserProfileInquiriesAsync.fulfilled,
    (state, actions: PayloadAction<IResponseWithPagination<IInquiry>>) => {
      state.inquiries.isLoading = false;
      state.inquiries.data = actions.payload;
    }
  );

  builder.addCase(getUserProfileInquiriesAsync.rejected, (state) => {
    state.inquiries.isLoading = false;
    state.inquiries.data = null;
  });
};
